import { createStore, combineReducers, applyMiddleware, compose } from "redux"
import shoppingCart from "../reducers/shoppingCart"
import thunk from "redux-thunk"
import { loadState } from "./localStorage"
import checkout from "../reducers/checkout"
import auth from "../reducers/auth"
import userMenu from "../reducers/userMenu"
import userOrders from "../reducers/userOrders"
import userInformation from "../reducers/userInformation"
import savedList from "../reducers/savedList"
const windowGlobal = typeof window !== "undefined" && window

const devtools =
  process.env.NODE_ENV === "development" && windowGlobal.devToolsExtension
    ? window.__REDUX_DEVTOOLS_EXTENSION__ &&
    window.__REDUX_DEVTOOLS_EXTENSION__({
      trace: true,
      traceLimit: 25
    })
    : f => f

const persistedState = loadState()

export default () => {



  const appReducer = combineReducers({
    shoppingCart: shoppingCart,
    checkout: checkout,
    auth: auth,
    userMenu: userMenu,
    userOrders: userOrders,
    userInformation: userInformation,
    savedList: savedList,
  })

  // rooter reducer to reset state back to default settings upon log out
  const rootReducer = (state, action) => {
    if (action.type === 'RESET_STATE') {
      state = undefined
      localStorage.removeItem('state') // clears the local sotrage state as well
    }
    return appReducer(state, action)
  }

  const store = createStore(
    rootReducer,
    persistedState,
    compose(applyMiddleware(thunk), devtools)
  )

  return store
}
